import React from 'react';
import style from './GoalCheckCard.module.css';

const DAYS = ['일', '월', '화', '수', '목', '금', '토'];

// status: 'success' | 'fail' | 'none'
const GoalCheckCard = ({ title, condition, days, color = 'blue' }) => {
    const achieved = days.filter(d => d === 'success').length;
    const total = days.length;

    return (
        <div className={style.card} data-color={color}>
            <div className={style.head}>
                <div className={style.titleBox}>
                    <strong className={style.title}>{title}</strong>
                    <span className={style.condition}>{condition}</span>
                </div>
                <span className={style.count}>
                    <b>{achieved}</b>/{total}
                </span>
            </div>

            <div className={style.week}>
                {DAYS.map((day, i) => {
                    const st = days[i] || 'none';
                    return (
                        <div key={i} className={style.dayCol}>
                            <span className={style.dayLabel}>{day}</span>
                            <span className={style.mark} data-status={st}>
                                {st === 'fail' ? (
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                        <path d="M4 4L10 10M10 4L4 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                ) : (
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                        <path d="M3 7L6 10L11 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                )}
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default GoalCheckCard;